/**
 * ViewBlock.
 * @module components/manage/Blocks/Timeline/View
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useIntl } from 'react-intl';
import { LinkMore } from '@plone/volto/components';
import { viewDate } from 'design-comuni-plone-theme/helpers';
import 'moment-timezone';

const timezone = 'Europe/Rome';

const ViewBlock = ({ data, isEditMode = false }) => {
  const intl = useIntl();

  const momentDate = data.card_date
    ? viewDate(intl.locale, data.card_date).tz(timezone)
    : null;

  const formattedDate = momentDate ? momentDate.format('D MMMM YYYY') : null;

  const hasTime =
    momentDate && (momentDate.hours() !== 0 || momentDate.minutes() !== 0);
  const formattedTime = hasTime ? momentDate.format('HH:mm') : null;

  const cardTextHtml =
    typeof data.card_text === 'object' ? data.card_text?.data : data.card_text;

  return (
    <div className="timeline-wrapper">
      <div className="card-date">
        <p>{data.card_date ? formattedDate : '-'}</p>
        <p className="card-time">{formattedTime || ' '}</p>
      </div>
      <div className="card-dot"></div>
      <div className="card-content-wrapper">
        <div className="card-content">
          <h4
            className={cx(
              'card-title',
              data.card_title_color
                ? 'card-title-' + data.card_title_color
                : '',
            )}
          >
            {data.card_title}
          </h4>
          <div
            className={cx(
              'card-text',
              data.card_text_color ? 'card-text-' + data.card_text_color : '',
            )}
          >
            {isEditMode && !cardTextHtml ? (
              <p>
                Inserisci la data, il titolo e il testo della card tramite la
                Sidebar sulla destra
              </p>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: cardTextHtml || '' }} />
            )}
          </div>
          <LinkMore data={data} isEditMode={isEditMode} />
        </div>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
ViewBlock.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default ViewBlock;
